import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Typography, makeStyles } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import InfiniteScroll from 'react-infinite-scroll-component'
import { usePurchasing } from '../../purchasing'
import InventoryLocationStockCard from './InventoryLocationStockCard'
import { fetchLocations } from '../slice'

const useStyles = makeStyles(theme => ({
  countLabel: {
    display: 'none',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      display: 'block',
    },
  },
}))

const InventoryEnvironmentList = ({ hasNextPage, onFetchMore }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { purchasingEnvironment } = usePurchasing()

  // Select the locations from the state
  const locations = useSelector(state => state.buyer.inventory.locations)
  const isLoading = useSelector(state => state.buyer.inventory.isLoading)

  useEffect(() => {
    dispatch(fetchLocations(purchasingEnvironment)) // Fetch the locations on component mount
  }, [dispatch, purchasingEnvironment])

  const total = locations.length
  const showingText = `Showing ${total} ${
    total === 1 ? 'location' : 'locations'
  }`

  return (
    <div>
      {!isLoading ? (
        <>
          <Typography
            className={classes.countLabel}
            variant="body2"
            color="textSecondary"
          >
            {showingText}
          </Typography>

          <InfiniteScroll
            dataLength={locations.length}
            next={onFetchMore}
            hasMore={hasNextPage}
          >
            {locations.map(location => (
              <>
                <InventoryLocationStockCard
                  location={location}
                  items={location.items}
                />
                <div style={{ height: 20 }} />
              </>
            ))}
          </InfiniteScroll>
        </>
      ) : (
        [1, 2, 3].map(() => (
          <Skeleton
            variant="rect"
            height={150}
            style={{
              borderRadius: 10,
              marginTop: 10,
              marginBottom: 9,
            }}
          />
        ))
      )}
    </div>
  )
}

InventoryEnvironmentList.defaultProps = {
  hasNextPage: false,
  suppliers: [],
  total: 0,
}

export default InventoryEnvironmentList
